import { URLS_CONFIG } from 'config';

export default id => URLS_CONFIG.admin.viewCompany.replace(':id', id);
